import BaseService from './BaseService'
import { ICategory } from '../interfaces/category'

class CategoryService extends BaseService {
  constructor() {
    super('category')
  }

  saveToCache(data: ICategory[]): void {
    data.forEach(category => {
      const cacheKey = `${this.model}_${category._id}`
      this.cache.set(cacheKey, category)
    })
  }

}

export default CategoryService
